import styled from 'styled-components';

const UnderlineComponent = styled.u``;
export const UnderlineEditable = UnderlineComponent;
export const UnderlineRenderer = UnderlineComponent;
